export default {
  recurring: {
    panelLabel: 'recurring.panel.label',
    help: {
      text: 'recurring.help.text.link',
      button: 'recurring.help.text.button',
    },
    history: {
      link: {
        showInvoice: 'recurring.history.link.showInvoice',
      },
    },
    blockLabel: 'invoiceEditor.recurring.label',
    frequency: {
      header: 'recurring.schedule.label',
      WEEKLY: 'recurring.schedule.weekly',
      BIWEEKLY: 'recurring.schedule.biweekly',
      MONTHLY: 'recurring.schedule.monthly',
      MONTHLY_LAST_DAY: 'recurring.schedule.monthly.last',
      QUARTERLY: 'recurring.schedule.quarterly',
      SEMIANNUALLY: 'recurring.schedule.semiannually',
      YEARLY: 'recurring.schedule.yearly',
    },
    duration: {
      header: 'recurring.duration.label',
      indefinite: 'recurring.duration.indefinite',
      repeat: 'recurring.duration.repeat',
      times: 'recurring.duration.times',
    },
    sending: {
      header: 'recurring.sending.label',
      createAndSend: 'recurring.sending.automatic',
      create: 'recurring.sending.manual',
    },
    confirmation: {
      label: 'recurring.confirmation.label',
    },
    starting: 'recurring.starting',
    editMessage: 'recurring.editMessage',
    repeated: 'recurring.repeated',
    invoice: 'recurring.invoice',
    email: 'recurring.email',
    create: 'Create',
    createProfile: 'recurring.createProfile',
    createInvoice: 'invoice.Create',
    invoices: 'Invoices',
    recurringProfiles: 'RecurringProfiles',
    list: {
      emptyState: {
        heading: 'recurring.grid.emptyState.header',
        text: 'recurring.grid.emptyState.info',
      },
      headers: {
        customer: 'recurring.customer',
        created: 'recurring.created',
        frequency: 'recurring.frequency',
        occurrence: 'recurring.occurrence',
        total: 'recurring.total',
        status: 'recurring.status',
      },
    },
    status: {
      draft: 'recurring.status.draft',
      active: 'recurring.status.active',
      inactive: 'recurring.status.inactive',
      started: 'recurring.status.started',
      paused: 'recurring.status.paused',
      completed: 'recurring.status.completed',
    },
    info: {
      title: 'recurring.info.title', // Recurring template
      buttons: {
        show: 'Show',
        edit: 'Edit',
        delete: 'Delete',
      },
      total: {
        net: 'recurring.info.net',
        vat: 'recurring.info.vat',
        gross: 'recurring.info.gross',
      },
      nextDate: 'recurring.info.next.date',
      repeated: 'recurring.info.repeated',
      period: 'recurring.info.period',
      sending: 'recurring.info.sending',
      delivery: 'recurring.info.delivery',
      created: 'recurring.info.created',
      emptyState: {
        heading: 'recurring.info.emptyState.header',
        text: 'recurring.info.emptyState.content',
      },
      tabs: {
        history: 'recurring.tab.history',
        rows: 'recurring.tab.rows',
        invoices: 'recurring.tab.invoices',
      },
    },
    setStatus: 'recurring.setStatus',
    confirmationModal: 'recurring.delete.confirmation',
    preview: {
      firstInvoice: 'recurring.preview.firstInvoice',
      frequency: 'recurring.preview.frequency',
      duration: 'recurring.preview.duration',
    },
    notification: {
      create: 'notifications.recurring.create.success',
      save: 'notifications.recurring.save.success',
    },
    start: 'recurring.preview.start',
  },
}
